import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user:{
      userId:"",
      userName:"",
      administrator:false,
      totp:false,
      lastLogin:null as Date|null,
      tpdata:{
        EmpCode:"",
        WordName:"",
        DepCodeAll:"",
        RetireFlag:0,
        RetireYMD:0,
        DepNameAll:"",
        BonusFlag0:0,
        BonusFlag1:0,
        BonusFlag2:0,
      },
      flags:{
        salaryResign:false,
      }
    },
    systemMessege:{
      color:"red",
      text:"",
      timeout:1500,
    },
    resinData:{},
    api:{
      sessionId:"",
    },
    apiSaver:{
      connection:false,
      apiRequest:null,
    },
  },
  mutations: {
    setUser(state,user){
      state.user.userId = user.userId;
      state.user.userName = user.userName;
      state.user.administrator = user.administrator?true:false;
      state.user.totp = user.totp?true:false;
      state.user.lastLogin = user.lastLogin;
      state.user.tpdata = user.tpdata;
      state.user.flags = user.flags;
    },
    setSysMessege(state,systemMessege){
      state.systemMessege.color = systemMessege.color;
      state.systemMessege.text = systemMessege.text;
      state.systemMessege.timeout = systemMessege.timeout;
    },
    setResinData(state,resignData){
      state.resinData = resignData;
    },
    api(state,api){
      if(api.sessionId){
        state.api = api.sessionId;
      }
    },
    setApiSaver(state,apiSaver){
      state.apiSaver.connection  = apiSaver.connection;
      state.apiSaver.apiRequest  = apiSaver.apiRequest;
    },
  },
  actions: {
  },
  modules: {
  }
})
